export const state = {
  token: undefined,
  lang: 'en',
  isLoading: false,
  activityDetails: {},
  engineerDetails: {},
  currentDate: new Date(),
  shouldShowIntercom: false,
  dismissNotification: false,
  mapInitComplete: false,
  calculatedEta: undefined,
  rescheduleDetails: undefined,
  apptWindowEnd: undefined,
  datasetId: undefined,
  clickOrigin: undefined,
  error: undefined,
  marketingCampaign: undefined,
};
